<template>
  <ValidationProvider v-slot="{ errors }" :name="$attrs.name" :rules="rules">
    <div :style="hidden ? `display: none` : ``">
      <v-text-field
        v-bind="{ ...$attrs }"
        :value="value"
        :error-messages="errors"
        :readonly="readonly"
        :background-color="errors.length > 0 ? `#ffcbc7` : ``"
        v-on="$listeners"
        @input="emit"
      >
        <template
          v-for="(_, scopedSlotName) in $scopedSlots"
          #[scopedSlotName]="slotData"
        >
          <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
        <template v-for="(_, slotName) in $slots" #[slotName]>
          <slot :name="slotName" />
        </template>
      </v-text-field>
    </div>
  </ValidationProvider>
</template>

<script>
import VonexFieldsMixin from '@/mixins/vonexfields.mixin';
export default {
  name: 'VonexText',
  mixins: [VonexFieldsMixin],
};
</script>
